/*
 *
 * File JS per la Homepage
 *
 */

import "./general.scss";

// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import initHeader from "components/header/header";
import accordion from "imComponents/accordion/accordion";
import breadcrumbs from "components/breadcrumbs/breadcrumbs";
import button from "components/buttons/buttons";
import cmsContent from "components/cms-content/cms-content";
import modal from "imComponents/modal/modal";
import heroSlider from "imComponents/hero-slider/hero-slider";
import heroImage from "imComponents/hero-image/hero-image";
import footer from "components/footer/footer";
import contactForm from "components/contact-form/contact-form";
import cardsTextBg from "components/cards-text-bg/cards-text-bg";
import textOnBg from "imComponents/text-on-bg/text-on-bg";
import textImgVar from "imComponents/text-img-var/text-img-var";
import customAccordion from "components/custom-accordion/custom-accordion";
import boxGallery from "imComponents/box-gallery/box-gallery";
import cardNews from "components/cards/card-news";
import sliderNews from "components/slider-news/slider-news";
import customQuote from "components/custom-quote/custom-quote";
import blockTwoImages from "components/block-two-images/block-two-images";
import boxImage from "components/box-image/box-image";
import colTitleText from "components/col-title-text/col-title-text";
import smallImgText from "components/small-img-text/small-img-text";
import menu from "components/menu/menu";
import cardTextOnBg from "components/cards/card-text-on-bg";
import archiveList from "components/archive-list/archive-list";
import textIframe from "components/text-iframe/text-iframe";

//--------------------------------------------------------------------//

// INIT COMPONENTI
//--------------------------------------------------------------------//
accordion();
initHeader();
modal();
heroSlider();
boxGallery();
sliderNews();
//--------------------------------------------------------------------//
